"use client";

import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { BottomSheetBody, BottomSheetFooter, BottomSheetHeader, BottomSheetHeaderTitle, Flex, Form, Media, Separator, SkeletonBlock, tv } from "@opensea/ui-kit";
import { useLocalStorage } from "@opensea/ui-kit/hooks";
import { useEffect, useMemo } from "react";
import { Controller, useFormContext, useFormState, useWatch } from "react-hook-form";
import { useTranslations } from "use-intl";
import { Button } from "../../../../../components/Button";
import { CreateOrdersSummary, CreateOrdersSummarySkeleton } from "../../../../../components/CreateOrdersSummary";
import { ExpirationSelect } from "../../../../../components/ExpirationSelect";
import { useIsFormSubmitDisabled } from "../../../../../lib/form/valid";
import { DEFAULT_EXPIRATION, LISTING_EXPIRATION_CUSTOM_EXPIRATION_LOCAL_STORAGE, LISTING_EXPIRATION_LOCAL_STORAGE } from "../../../constants";
import { ListingFlowHeaderActions, ListingFlowHeaderActionsSkeleton } from "../ListingFlowHeaderActions";
import { ListingFlowItemsTable, ListingFlowItemsTableSkeleton } from "../ListingFlowItemsTable/ListingFlowItemsTable";
import { ListingFlowForm_itemFragment } from "./ListingFlowForm.fragment";
const footerVariants = tv({
  slots: {
    buttonContainer: "grid grid-cols-2 gap-3 pb-4 md:flex md:justify-end md:pb-0"
  }
});
export const ListingFlowForm = t0 => {
  const $ = _c(85);
  const {
    items: itemKeys,
    onSubmit
  } = t0;
  const t = useTranslations("wallet.ListingFlowForm");
  const items = itemKeys.map(_temp);
  const {
    control,
    handleSubmit,
    setValue
  } = useFormContext();
  let t1;
  if ($[0] !== control) {
    t1 = {
      control
    };
    $[0] = control;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    errors
  } = useFormState(t1);
  let t2;
  if ($[2] !== control) {
    t2 = {
      control,
      name: "listings"
    };
    $[2] = control;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const listings = useWatch(t2);
  let t3;
  if ($[4] !== control) {
    t3 = {
      control,
      name: "adjustForFees"
    };
    $[4] = control;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const adjustForFees = useWatch(t3);
  let t4;
  if ($[6] !== listings) {
    t4 = listings.some(_temp2);
    $[6] = listings;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const creatorFeeEnforced = t4;
  const [, setListingExpiration] = useLocalStorage(LISTING_EXPIRATION_LOCAL_STORAGE, DEFAULT_EXPIRATION);
  const [, setListingExpirationCustom] = useLocalStorage(LISTING_EXPIRATION_CUSTOM_EXPIRATION_LOCAL_STORAGE, undefined);
  const tableItems = listings.flatMap(listing_0 => {
    const matchedItem = items.find(item => item.id === listing_0.id);
    return matchedItem ? [matchedItem] : [];
  });
  const isEditListing = tableItems.every(_temp3);
  let t5;
  if ($[8] !== control) {
    t5 = {
      control,
      name: "applyCreatorFee"
    };
    $[8] = control;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const globalApplyCreatorFee = useWatch(t5);
  let t6;
  if ($[10] !== globalApplyCreatorFee || $[11] !== listings || $[12] !== setValue) {
    t6 = () => {
      listings.forEach((__0, index) => {
        setValue(`listings.${index}.applyCreatorFee`, globalApplyCreatorFee);
      });
    };
    $[10] = globalApplyCreatorFee;
    $[11] = listings;
    $[12] = setValue;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== globalApplyCreatorFee || $[15] !== listings.length || $[16] !== setValue) {
    t7 = [globalApplyCreatorFee, listings.length, setValue];
    $[14] = globalApplyCreatorFee;
    $[15] = listings.length;
    $[16] = setValue;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  useEffect(t6, t7);
  let t8;
  if ($[18] !== control) {
    t8 = {
      control,
      name: "reservedBuyer.resolvedAddress"
    };
    $[18] = control;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  const isPrivateListing = Boolean(useWatch(t8));
  let t9;
  if ($[20] !== isPrivateListing || $[21] !== items || $[22] !== listings || $[23] !== setValue) {
    t9 = () => {
      listings.forEach((__1, index_0) => {
        setValue(`listings.${index_0}.openSeaFeeBasisPoints`, isPrivateListing ? 0 : items[index_0].collection?.fees.openseaFee?.feeBasisPoints || 0);
      });
    };
    $[20] = isPrivateListing;
    $[21] = items;
    $[22] = listings;
    $[23] = setValue;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== isPrivateListing || $[26] !== listings.length || $[27] !== setValue) {
    t10 = [isPrivateListing, listings.length, setValue];
    $[25] = isPrivateListing;
    $[26] = listings.length;
    $[27] = setValue;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  useEffect(t9, t10);
  const isFormSubmitDisabled = useIsFormSubmitDisabled(control);
  let t11;
  let t12;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = footerVariants().buttonContainer();
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== errors.expiration?.customExpiration?.message || $[31] !== setListingExpiration || $[32] !== setListingExpirationCustom) {
    t13 = t14 => {
      const {
        field
      } = t14;
      return <ExpirationSelect className="w-full" customDate={field.value.customExpiration} error={errors.expiration?.customExpiration?.message} onChange={value => {
        field.onChange({
          ...field.value,
          expirationType: value
        });
        setListingExpiration(value);
      }} onCustomDateChange={date => {
        field.onChange({
          ...field.value,
          customExpiration: date
        });
        setListingExpirationCustom(date.toISOString());
      }} value={field.value.expirationType} />;
    };
    $[30] = errors.expiration?.customExpiration?.message;
    $[31] = setListingExpiration;
    $[32] = setListingExpirationCustom;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== control || $[35] !== t13) {
    t14 = <Controller control={control} name="expiration" render={t13} />;
    $[34] = control;
    $[35] = t13;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  if ($[37] !== isEditListing || $[38] !== listings.length || $[39] !== t) {
    t15 = isEditListing ? t("editButton") : t("reviewButton", {
      count: listings.length
    });
    $[37] = isEditListing;
    $[38] = listings.length;
    $[39] = t;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  let t16;
  if ($[41] !== isFormSubmitDisabled || $[42] !== t15) {
    t16 = <Button disabled={isFormSubmitDisabled} type="submit">{t15}</Button>;
    $[41] = isFormSubmitDisabled;
    $[42] = t15;
    $[43] = t16;
  } else {
    t16 = $[43];
  }
  let t17;
  if ($[44] !== t14 || $[45] !== t16) {
    t17 = <Flex className={t12}>{t14}{t16}</Flex>;
    $[44] = t14;
    $[45] = t16;
    $[46] = t17;
  } else {
    t17 = $[46];
  }
  t11 = t17;
  const footer = t11;
  let t18;
  if ($[47] !== handleSubmit || $[48] !== onSubmit) {
    t18 = handleSubmit(onSubmit);
    $[47] = handleSubmit;
    $[48] = onSubmit;
    $[49] = t18;
  } else {
    t18 = $[49];
  }
  let t19;
  if ($[50] !== isEditListing || $[51] !== listings.length || $[52] !== t) {
    t19 = isEditListing ? t("editTitle", {
      count: listings.length
    }) : t("createTitle", {
      count: listings.length
    });
    $[50] = isEditListing;
    $[51] = listings.length;
    $[52] = t;
    $[53] = t19;
  } else {
    t19 = $[53];
  }
  let t20;
  if ($[54] !== t19) {
    t20 = <BottomSheetHeaderTitle className="whitespace-nowrap">{t19}</BottomSheetHeaderTitle>;
    $[54] = t19;
    $[55] = t20;
  } else {
    t20 = $[55];
  }
  const t21 = items[0]?.chain.listingCurrency.symbol || "ETH";
  let t22;
  if ($[56] !== t21) {
    t22 = <Media greaterThanOrEqual="md"><ListingFlowHeaderActions listingSymbol={t21} /></Media>;
    $[56] = t21;
    $[57] = t22;
  } else {
    t22 = $[57];
  }
  let t23;
  if ($[58] !== t20 || $[59] !== t22) {
    t23 = <BottomSheetHeader className="justify-between">{t20}{t22}</BottomSheetHeader>;
    $[58] = t20;
    $[59] = t22;
    $[60] = t23;
  } else {
    t23 = $[60];
  }
  const t24 = items[0]?.chain.listingCurrency.symbol || "ETH";
  let t25;
  if ($[61] !== t24) {
    t25 = <Media lessThan="md"><ListingFlowHeaderActions className="pb-4" listingSymbol={t24} /></Media>;
    $[61] = t24;
    $[62] = t25;
  } else {
    t25 = $[62];
  }
  let t26;
  if ($[63] !== items) {
    t26 = <ListingFlowItemsTable isReview={false} items={items} />;
    $[63] = items;
    $[64] = t26;
  } else {
    t26 = $[64];
  }
  let t27;
  if ($[65] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <Separator className="mt-1" />;
    $[65] = t27;
  } else {
    t27 = $[65];
  }
  let t28;
  if ($[66] !== adjustForFees || $[67] !== creatorFeeEnforced || $[68] !== items[0] || $[69] !== listings) {
    t28 = items[0]?.collection && <CreateOrdersSummary adjustForFees={adjustForFees} className="md:w-fit" collection={items[0].collection} creatorFeeEnforced={creatorFeeEnforced} currencyIdentifier={{
      contractAddress: items[0].collection.chain.listingCurrency.address,
      chainIdentifier: items[0].collection.chain.identifier
    }} orderSide="listing" orders={listings} symbol={items[0].collection.chain.listingCurrency.symbol} />;
    $[66] = adjustForFees;
    $[67] = creatorFeeEnforced;
    $[68] = items[0];
    $[69] = listings;
    $[70] = t28;
  } else {
    t28 = $[70];
  }
  let t29;
  if ($[71] !== footer) {
    t29 = <Media lessThan="md">{footer}</Media>;
    $[71] = footer;
    $[72] = t29;
  } else {
    t29 = $[72];
  }
  let t30;
  if ($[73] !== t25 || $[74] !== t26 || $[75] !== t28 || $[76] !== t29) {
    t30 = <BottomSheetBody className="mt-2 pb-0">{t25}{t26}{t27}{t28}{t29}</BottomSheetBody>;
    $[73] = t25;
    $[74] = t26;
    $[75] = t28;
    $[76] = t29;
    $[77] = t30;
  } else {
    t30 = $[77];
  }
  let t31;
  if ($[78] !== footer) {
    t31 = <Media greaterThanOrEqual="md"><BottomSheetFooter>{footer}</BottomSheetFooter></Media>;
    $[78] = footer;
    $[79] = t31;
  } else {
    t31 = $[79];
  }
  let t32;
  if ($[80] !== t18 || $[81] !== t23 || $[82] !== t30 || $[83] !== t31) {
    t32 = <Form onSubmit={t18}>{t23}{t30}{t31}</Form>;
    $[80] = t18;
    $[81] = t23;
    $[82] = t30;
    $[83] = t31;
    $[84] = t32;
  } else {
    t32 = $[84];
  }
  return t32;
};
export function ListingFlowFormSkeleton(t0) {
  const $ = _c(22);
  const {
    count
  } = t0;
  const t = useTranslations("wallet.ListingFlowForm");
  let t1;
  if ($[0] !== count || $[1] !== t) {
    t1 = t("createTitle", {
      count
    });
    $[0] = count;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <BottomSheetHeaderTitle>{t1}</BottomSheetHeaderTitle>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== count) {
    t3 = <Media greaterThanOrEqual="md"><ListingFlowHeaderActionsSkeleton count={count} /></Media>;
    $[5] = count;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <BottomSheetHeader className="justify-between">{t2}{t3}</BottomSheetHeader>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  let t6;
  if ($[10] !== count) {
    t5 = <Media lessThan="md"><ListingFlowHeaderActionsSkeleton className="pb-4" count={count} /></Media>;
    t6 = <ListingFlowItemsTableSkeleton count={count} />;
    $[10] = count;
    $[11] = t5;
    $[12] = t6;
  } else {
    t5 = $[11];
    t6 = $[12];
  }
  let t7;
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Separator className="mt-1" />;
    t8 = <CreateOrdersSummarySkeleton orderSide="listing" />;
    $[13] = t7;
    $[14] = t8;
  } else {
    t7 = $[13];
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t5 || $[16] !== t6) {
    t9 = <BottomSheetBody>{t5}{t6}{t7}{t8}</BottomSheetBody>;
    $[15] = t5;
    $[16] = t6;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <BottomSheetFooter><Flex className={footerVariants().buttonContainer()}><SkeletonBlock className="h-10 w-full rounded md:w-44" /><SkeletonBlock className="h-10 w-full rounded md:w-24" /></Flex></BottomSheetFooter>;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t4 || $[20] !== t9) {
    t11 = <>{t4}{t9}{t10}</>;
    $[19] = t4;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  return t11;
}
function _temp(itemKey) {
  return {
    ...readFragment(ListingFlowForm_itemFragment, itemKey)
  };
}
function _temp2(listing) {
  return listing.isCreatorFeeRequired;
}
function _temp3(item_0) {
  return item_0.lowestListingForOwner && !item_0.isFungible;
}